import React, { useEffect, useState } from 'react';
import CascadeTemplate from '@nile/banyan/src/Components/Cascades/CascadeTemplate';
import { AccountClient, GET_FIELD } from '@nile/graphql';
import {
  ALL_MODULES,
  ALL_SHARD_MODULES,
  NEW_MODULE_MAP,
  TableLoading
} from '@nile/components';

type ResourceChildType = {
  children: React.ReactNode;
};
type Option = {
  id: String;
  value: String;
  order: Number;
  description: String;
  details: JSON;
  parentOption: Option;
  deletable: Boolean;
};

type ParentFieldType = {
  id: String;
  module: String;
  columnName: String;
  label: String;
  description: String;
  fieldType:
    | 'TEXT'
    | 'PARAGRAPH'
    | 'NUMERIC'
    | 'DECIMAL'
    | 'DATE'
    | 'DATETIME'
    | 'RADIO'
    | 'CHECKBOX'
    | 'SELECT'
    | 'MULTI_SELECT'
    | 'PASSWORD'
    | 'SECURE_TEXT';
  options: [Option];
  showToClient: Boolean;
  fieldCategory: 'CUSTOM' | 'DEFAULT';
  mandatoryOnCreate: Boolean;
  mandatoryOnClosure: Boolean;
  editable: Boolean;
  parentField: ParentFieldType;
};

function CascadeTemplateContainer({
  parentField,
  resourceChild
}: {
  parentField: ParentFieldType;
  resourceChild: ResourceChildType;
}) {
  const [parentFields, setParentFields] = useState({});
  const [errors, setErrors] = useState(null);
  const [fieldLoading, setFieldLoading] = useState(true);

  /**
   *To get the parent options and its child options while selecting the parent field
   */
  const getParentField = () => {
    setFieldLoading(true);
    AccountClient.query({
      query: GET_FIELD,
      variables: {
        input: {
          entity:
            NEW_MODULE_MAP[parentField?.module] || ALL_SHARD_MODULES.ticket,
          id: parentField?.id
          // columnName: columnName
        }
        // input: {
        //   id: parentField?.id,
        //   columnName: parentField?.columnName,
        //   module: parentField?.module || ALL_MODULES.ticket
        // }
      }
    })
      .then((res) => {
        setParentFields(res?.data?.getField);
      })
      .finally(() => setFieldLoading(false));
  };

  useEffect(() => {
    if (parentField?.id) getParentField();
  }, [parentField?.id]);

  if (fieldLoading) {
    return (
      <div className="fx w100 h-300">
        <TableLoading slide rows={4} />
      </div>
    );
  }
  return (
    <div className="cascade-parent">
      <CascadeTemplate
        resources={{
          header: parentFields?.label || '',
          data: parentFields?.options || []
        }}
        resourceChild={resourceChild}
        errors={errors}
      />
    </div>
  );
}

export default CascadeTemplateContainer;
